import { Injectable } from '@angular/core'
import { Query } from '@datorama/akita'
import { UserStore, UserState } from './user.store'

@Injectable({ providedIn: 'root' })
export class UserQuery extends Query<UserState> {
  constructor(protected store: UserStore) {
    super(store)
  }

  profile$ = this.select(state => state.profile)

  settings$ = this.select(state => state.settings)

  get hasSettings(): boolean {
    return !!this.getValue().settings
  }
}
